import { createTheme } from '@material-ui/core/styles'

// #0044ff
export const PHP_COLOR = {
    primary: {
        main: '#00338E',
        light: '#80ABF3',
        medium: '#3379EC',
        dark: '#000B9B',
    },
    secondary: {
        main: '#FFA600',
        light: '#FFD280',
        medium: '#FFB833',
        dark: '#EB8C14',
    },
    white: '#FFFFFF',
    blue: {
        light: '#002C75'
    },
    font: {
        main: '#15141A',
        error: '#D83E1A',
        success: '#00B57D',
    }
}

export const DIGITAL_UI = {
    footer: '#001E50',
    header: '#FFFFFF',
    hover: '#FFFFFF',
    disabled: '#5C6B7A',
    accent: '#CBC5BE',
    status: {
        error: '#D83E1A',
        success: '#00B57D',
        warning: '#FFD422',
    },
    states: {
        active: '#00338E'
    },
    typography: {
        primary: '#15141A',
        link: '#00338E',
        dark: '#FFFFFF',
    }
}

export const PHP_FONT = {
    primary: {
        fontFamily: [
            'Barlow',
            'sans-serif'
        ].join(','),
        fontStyle: 'normal',
        fontWeight: 600,
        fontSize: '1rem',
    },
    header: {
        fontFamily: [
            'Lora',
            'sans-serif'
        ].join(','),
        fontStyle: 'normal',
        fontWeight: 600,
        fontSize: '41px',
        color: '#15141A',
    }
}

export const theme = createTheme({
    palette: {
        primary: {
            ...PHP_COLOR.primary,
        },
        secondary: {
            ...PHP_COLOR.secondary,
        },
        text: {
            primary: PHP_COLOR.font.main,
            secondary: PHP_COLOR.font.main,
        },
        error: {
            main: PHP_COLOR.font.error,
        },
        success: {
            main: PHP_COLOR.font.success,
        }
    },
    typography: {
        fontFamily: [
            'Barlow',
            'sans-serif',
        ].join(','),
    },
    overrides: {
        MuiIconButton: {
            root: {
                color: DIGITAL_UI.disabled,
            },
        },
        MuiInput: {
            underline: {
                '&:before':{
                    borderBottomWidth: "2px",
                    borderBottomColor: DIGITAL_UI.accent
                },
                '&:after':{
                    borderBottomWidth: "2px",
                    borderBottomColor: PHP_COLOR.primary.main
                },
            }
        },
        MuiInputLabel: {
            root: {
                color: DIGITAL_UI.disabled,
                fontSize: "18px",
                "&$focused":{
                    color: PHP_COLOR.primary.main
                },
                "&$error":{
                    color: DIGITAL_UI.status.error
                }
            },
            
        },
        MuiChip: {
            root: {
                //fix alert text hidden in overflow
                "@media only screen and (max-width: 830px)":{
                    padding: "22px" 
                },
                "@media only screen and (max-width: 409px)":{
                    padding: "33px"
                },
                "@media only screen and (max-width: 348px)":{
                    padding: "40px"
                },
            },
            label: {
                whiteSpace: "pre-wrap",
            },
            outlinedSecondary: {
                border: "2px solid #FFD422"
            },
        },
        MuiTypography: {
            h2: {
                ...PHP_FONT.header,
            },
        },
        MuiTableCell: {
            root: {
                padding: "10px",
            },
        },
        MuiCheckbox: {
            root: {
                color: "#CBC5BE",
            }
        },
        MuiSelect: {
            root: {
                fontSize: "18px",
                color: "#5C6B7A"
            }
        },
        MuiLink: {
            root: {
                fontWeight: 600,
            }
        },
        MuiButton: {
            contained: {
                ...PHP_FONT.primary,
                backgroundColor: PHP_COLOR.primary.main,
                borderRadius: 28,
                border: `2px solid ${PHP_COLOR.primary.main}`,
                textTransform: "none",
                height: 55,
                width: 180,
                fontSize: "18px",
                padding: [[11, 18]],
                color: PHP_COLOR.white,
                '&:hover': {
                    backgroundColor: DIGITAL_UI.hover + " !important",
                    border: `2px solid ${PHP_COLOR.primary.main}`,
                    color: PHP_COLOR.primary.main
                },
                '&:disabled': {
                    backgroundColor: DIGITAL_UI.disabled,
                    border: DIGITAL_UI.disabled,
                    color: PHP_COLOR.white,
                },
                '@media only screen and (max-width: 650px)': {
                    fontSize: '14px'
                },
            },
            outlined: {
                ...PHP_FONT.primary,
                backgroundColor: PHP_COLOR.white,
                borderRadius: 28,
                border: `2px solid ${PHP_COLOR.primary.main}`,
                height: 55,
                width: 180,
                padding: [[11, 36]],
                color: PHP_COLOR.primary.main,
                '&:hover, &:focus, &:active, &:visited': {
                    backgroundColor: '#DAE7FB', // PHP_COLOR.primary.light,
                    border: `2px solid ${DIGITAL_UI.hover}`,
                    color: DIGITAL_UI.hover,
                },
                '&:disabled': {
                    border: `2px solid ${DIGITAL_UI.disabled}`,
                    color: DIGITAL_UI.disabled,
                },
                '&.Mui-disabled:focus': {
                    border: `2px solid ${DIGITAL_UI.disabled}`,
                    color: DIGITAL_UI.disabled,
                },
                '&.Mui-disabled:active': {
                    border: `2px solid ${DIGITAL_UI.disabled}`,
                    color: DIGITAL_UI.disabled,
                },
                '&.Mui-disabled:hover': {
                    border: `2px solid ${DIGITAL_UI.disabled}`,
                    color: DIGITAL_UI.disabled,
                },
                '@media only screen and (max-width: 650px)': {
                    fontSize: '14px'
                },
            },
        },
    },
})
